import { DropDown } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getTextColor } from "../../utils/helpers";
import { useFilingStatus } from "../../hooks/useFilingStatus";

export const FilingStatusDropdown = ({ id, value, change, disabled }) => {
  const { i18n } = useTranslation(["Overlay", "Shared"], {
    useSuspense: false,
  });

  const filingStatus = useFilingStatus();

  const [backgroundColor, setBackgroundColor] = useState(
    filingStatus?.data?.find((x) => x.Id === value)?.Color
  );

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--dropdown-bg-filing-color",
      backgroundColor
    );

    document.documentElement.style.setProperty(
      "--dropdown-filing-color",
      getTextColor(backgroundColor)
    );
  }, [backgroundColor]);

  const handleChange = (args) => {
    /* Syncfusion fires `change` on open/close without a user selection when it
       normalizes the bound value (e.g. null shown as the default status),
       which triggered a task update just by opening the dropdown. Only
       propagate changes the user actually made. */
    if (!args?.isInteracted) return;

    const selectedColor = args.itemData?.Color;
    setBackgroundColor(selectedColor);

    args.id = id;
    change?.(args);
  };

  return (
    <div className="filing-status-dd w-25">
      <DropDown
        change={handleChange}
        name="FilingStatusId"
        value={value}
        dataSource={filingStatus?.data}
        fields={{ text: "Title", value: "Id" }}
        htmlFor={id}
        id={id}
        style={{
          "--dropdown-bg-filing-color": backgroundColor,
          "--dropdown-filing-color": getTextColor(backgroundColor),
        }}
        enabled={!disabled}
        locale={i18n?.language}
      />
    </div>
  );
};
